import { SubmitToRdComponent } from './submit-to-rd.component';
export var submitToRdRoutes = [
    {
        path: 'submitToRd',
        component: SubmitToRdComponent,
        data: {
            'expectedRoles': ['Accountant Admin', 'IT', 'Accountant']
        },
    },
];
var SubmitToRdRoutingModule = (function () {
    function SubmitToRdRoutingModule() {
    }
    return SubmitToRdRoutingModule;
}());
export { SubmitToRdRoutingModule };



// WEBPACK FOOTER //
// /opt/app/src/app/features/submit-to-rd/submit-to-rd-routing.module.ts.pre-build-optimizer.js